import styled from 'styled-components';

export const InstructionsSection = styled.section`
`;

export const InstructionsHeading = styled.h2`
  margin: 0;
  margin-bottom: 30px;
  padding: 0;
  
  font-size: 22px;
  line-height: 1;
  
  @media (min-width: 768px) {
    margin-bottom: 20px;
    
    font-size: 24px;
  }
`;

export const InstructionsList = styled.ol`
  margin: 0;
  padding: 0;
  
  list-style: none;
  counter-reset: instruction;
  
  @media (min-width: 1024px) {
    display: flex;
    justify-content: space-between;
  }
  
  li {
    position: relative;
    
    padding: 15px 0;
    padding-left: 50px;
    
    font-size: 14px;
    line-height: 20px;
    
    counter-increment: instruction;
    
    &::before {
      content: counter(instruction);
      
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      
      font-weight: 700;
      font-size: 16px;
      line-height: 1;
      color: ${({ theme }) => theme.white};
      
      border-radius: 50%;
      background-image: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
      box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);
    }
    
    @media (min-width: 768px) {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    
    @media (min-width: 1024px) {
      display: flex;
      align-items: center;
      
      width: max-content;
      max-width: 30%;
    }
  }
`;
